import React from 'react'
import { alpha, BackgroundImage, Box, Center } from '@mantine/core'

/**
 * Renders a banner component with an optional image. If the image exists, the color becomes 50% transparent.
 * @param {string} [imageSrc] Optional image source.
 * @param {string} color The background color for the banner in hex format.
 * @param {JSX.Element} children The content for the banner.
 * @returns {JSX.Element}
 */
function Banner ({ imageSrc, color, children }) {
  return (
    imageSrc
      ? <BackgroundImage src={imageSrc} w="100%" h="35vh" bgsz="cover">
        <Box bg={alpha(color, '0.5')} h="100%">
          <Center h="100%">
            {children}
          </Center>
        </Box>
      </BackgroundImage>
      : <Box bg={color} h="35vh" w="100%">
        <Center h="100%">
          {children}
        </Center>
      </Box>
  )
}

export default React.memo(Banner)
